export default function IconError() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Warning">
        <g id="Vector">
          <path
            d="M9.37497 8.12515V11.2502C9.37497 11.5953 9.65479 11.8752 9.99997 11.8752C10.3451 11.8752 10.625 11.5953 10.625 11.2502V8.12515C10.625 7.77997 10.3451 7.50015 9.99997 7.50015C9.65479 7.50015 9.37497 7.77997 9.37497 8.12515Z"
            fill="#FF4747"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.38097 2.81205C8.38097 2.81205 8.63022 2.37809 9.06332 2.12694C9.06332 2.12694 9.49777 1.875 9.99999 1.875C9.99999 1.875 10.5022 1.875 10.9367 2.12694C10.9367 2.12694 11.3711 2.37888 11.6206 2.81476L18.494 14.6871C18.494 14.6871 18.7451 15.122 18.7456 15.6235C18.7456 15.6235 18.746 16.1251 18.496 16.5598C18.496 16.5598 18.246 16.9946 17.8124 17.2465C17.8124 17.2465 17.3787 17.4984 16.8772 17.5002L3.12499 17.5002C3.12499 17.5002 2.62127 17.4984 2.18761 17.2465C2.18761 17.2465 1.75394 16.9946 1.50395 16.5598C1.50395 16.5598 1.25395 16.1251 1.2544 15.6235C1.2544 15.6235 1.25484 15.122 1.5056 14.6877L8.37941 2.81476L8.38097 2.81205ZM2.58813 15.3127L9.46267 3.43849L9.46427 3.43571L9.46462 3.4351C9.46462 3.4351 9.54704 3.2914 9.69038 3.20828C9.69038 3.20828 9.83399 3.125 9.99999 3.125C9.99999 3.125 10.166 3.125 10.3096 3.20828C10.3096 3.20828 10.4532 3.29155 10.5357 3.43563L17.4122 15.3133C17.4122 15.3133 17.4954 15.4575 17.4956 15.6247C17.4956 15.6247 17.4957 15.7918 17.4124 15.9367C17.4124 15.9367 17.3291 16.0817 17.1845 16.1656C17.1845 16.1656 17.04 16.2496 16.8728 16.2502L3.12499 16.2502C3.12499 16.2502 2.96002 16.2496 2.81547 16.1656C2.81547 16.1656 2.67091 16.0817 2.58758 15.9368C2.58758 15.9368 2.50425 15.7918 2.5044 15.6247C2.5044 15.6247 2.50454 15.4575 2.58813 15.3127Z"
            fill="#FF4747"
          ></path>
          <path
            d="M10.9375 14.0627C10.9375 14.5804 10.5177 15.0002 9.99997 15.0002C9.48224 15.0002 9.06247 14.5804 9.06247 14.0627C9.06247 13.5449 9.48224 13.1252 9.99997 13.1252C10.5177 13.1252 10.9375 13.5449 10.9375 14.0627Z"
            fill="#FF4747"
          ></path>
        </g>
      </g>
    </svg>
  );
}
